import { createSlice } from '@reduxjs/toolkit';

import { getVenuePresets } from '@/domain/project-venue-presets/actions/get-venue-presets.action.ts';
import { VenuePreset } from '@/domain/project-venue-presets/entities/project-venue-presets.entity.ts';

export type ProjectVenuePresetsState = {
  items: VenuePreset[];
};

const initialState: ProjectVenuePresetsState = {
  items: [],
};

export const projectVenuePresetsSlice = createSlice({
  name: 'projectVenuePresets',
  initialState,
  reducers: {
    clearItems(state) {
      state.items = [];
    },
  },
  extraReducers(builder) {
    builder.addCase(getVenuePresets.fulfilled, (state, action) => {
      state.items = action.payload;
    });
  },
});
